import React, { createContext, useCallback, useState, useEffect } from 'react';

export interface ReportContextValue {
  registerWidget: () => void;
  widgetLoaded: () => void;
  allWidgetsLoaded: boolean;
  totalWidgets: number;
  widgetsLoaded: number;
}

export const ReportContext = createContext<ReportContextValue>({
  registerWidget: () => {},
  widgetLoaded: () => {},
  allWidgetsLoaded: false,
  totalWidgets: 0,
  widgetsLoaded: 0,
});

export const ReportProvider: React.FC<{
  onAllLoaded: () => void;
  children: React.ReactNode;
}> = ({ onAllLoaded, children }) => {
  const [totalWidgets, setTotalWidgets] = useState(0);
  const [widgetsLoaded, setWidgetsLoaded] = useState(0);

  const registerWidget = useCallback(() => {
    setTotalWidgets((t) => t + 1);
  }, []);

  const widgetLoaded = useCallback(() => {
    setWidgetsLoaded((l) => l + 1);
  }, []);

  useEffect(() => {
    if (totalWidgets > 0 && widgetsLoaded === totalWidgets) {
      onAllLoaded();
    }
  }, [widgetsLoaded, totalWidgets, onAllLoaded]);

  return (
    <ReportContext.Provider
      value={{
        registerWidget,
        widgetLoaded,
        allWidgetsLoaded: totalWidgets > 0 && widgetsLoaded === totalWidgets,
        totalWidgets,
        widgetsLoaded,
      }}
    >
      {children}
    </ReportContext.Provider>
  );
};
